import {H3Text, H5Text} from '../../../components/core/text';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {BottomButton} from '../../../components/composites/Button';
import {Box} from '../../../components/core/view';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import React from 'react';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface ReceiptModalProps {
  onClose: () => void;
}

export function ReceiptModal(props: ReceiptModalProps) {
  const {onClose} = props;
  const theme = useColorThemeType();
  const mortiseFont = useFontTheme('mortise');
  const muliFont = useFontTheme('muli');
  const {title, body, button} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  return (
    <Box style={styles.mainContainer}>
      <H3Text
        style={[
          styles.headerText,
          {
            color: theme?.text.blue[300],
            fontFamily: mortiseFont[700].normal,
          },
        ]}>
        {title?.attention}
      </H3Text>
      <H5Text
        style={[
          {
            fontFamily: muliFont[700].normal,
            color: theme?.text.gray[100],
          },
        ]}>
        {body?.mandatoryReceipt}
      </H5Text>
      <BottomButton
        title={button?.ok}
        style={styles.buttonStyle}
        onPress={onClose}
      />
    </Box>
  );
}
